<template>
  <div id="fund-report">
    <div id="page-head">
      <ul id="breadcrumbs">
        <li>
          <router-link :to="{ name: 'Dashboard' }">Dashboard</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'BudgetIndex' }">Budget Manager</router-link>
        </li>
        <li>Fund Report</li>
      </ul>
    </div>

    <div class="panel">
      <div class="panel-head">
        <h2>Fund Report</h2>
      </div>
      <div class="panel-content">


        <div class="search">
          <div class="row">
            <div class="col">
              <div class="form-control-group">
                <div class="form-control">
                  <label for="month">Year</label>
                  <select v-model="year" name="month" id="month">
                    <option :value="currentYear - 2">{{ currentYear - 2 }}</option>
                    <option :value="currentYear - 1">{{ currentYear - 1 }}</option>
                    <option :value="currentYear">{{ currentYear }}</option>
                    <option :value="parseInt(currentYear) + 1">{{ parseInt(currentYear) + 1 }}</option>
                  </select>
                </div>
                <div class="form-control">
                  <label for="month">Month</label>
                  <select v-model="month" name="month" id="month">
                    <option v-for="(month, i) in months" :key="i" :value="i+1">{{ month }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col"></div>
          </div>
        </div>


        <div class="hours-estimate">
          <label class="switch">
            <input type="checkbox" v-model="toggleFilters" />
            <span class="slider"></span>
            <span class="switch-text">Toggle All Filters</span>
          </label>
        </div>
        <fieldset>
          <legend>Filters</legend>
          <div class="filters">
            <label v-for="filter in filters">
              <input type="checkbox" v-model="filter.enabled" />
              {{ filter.name }}
            </label>
          </div>
        </fieldset>

        <template v-if="pausedNetworks">
          <h2 @click="toggleOpen" :class="{'toggle-trigger': true, 'is-open': this.isOpen}">
            <i class="fa fa-caret-right"></i> Paused Networks ({{ filteredPausedFunds.length }})
          </h2>
          <table :class="{'toggle-table': true, 'is-open': this.isOpen}">
            <thead>
              <tr>
                <th>Client</th>
                <th>Fund Type</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="paused in filteredPausedFunds">
                <td>{{ paused.client }}</td>
                <td>{{ paused.type }}</td>
              </tr>
            </tbody>
          </table>
        </template>

        <h2>Active Networks</h2>
        <table>
          <thead>
            <tr>
              <th>Client</th>
              <th>Fund Type</th>
              <th>Projected</th>
              <th>Actual</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="fund in filteredFunds">
              <td>{{ fund.client }}</td>
              <td>{{ fund.type }}</td>
              <td>{{ fund.projected ? '$' + fund.projected.toLocaleString() : '--' }}</td>
              <td>{{ fund.actual ? '$' + fund.actual.toLocaleString(): '--' }}</td>
            </tr>
          </tbody>
        </table>

        <table class="totals">
          <thead>
            <tr>
              <th></th>
              <th>Projected Total</th>
              <th>Actual Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Selected Totals</td>
              <td>${{ projectedTotal.toLocaleString() }}</td>
              <td>${{ actualTotal.toLocaleString() }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
export default {
  name: "FundReport",
  data() {
    return {
      funds: [],
      prevFunds: [],
      isOpen: false,
      toggleFilters: 1,
      months: moment.months(),
      currentYear: moment().format("YYYY"),
      filters: [
        { name: "Adelphic", enabled: true },
        { name: "Display & Video 360", enabled: true },
        { name: "El Toro", enabled: true },
        { name: "Facebook Advertising", enabled: true },
        { name: "Google Ads", enabled: true },
        { name: "Google Ads (Post-Pay)", enabled: true },
        { name: "Google Local Service Ads", enabled: true },
        { name: "LinkedIn Ads", enabled: true },
        { name: "Microsoft Advertising", enabled: true },
        { name: "Misc", enabled: true },
        { name: "NextDoor Ads", enabled: true },
        { name: "Pinterest", enabled: true },
        { name: "Reddit", enabled: true },
        { name: "Snapchat Ads", enabled: true },
        { name: "The Trade Desk", enabled: true },
        { name: "TikTok", enabled: true },
        { name: "Twitter Ads", enabled: true },
      ],
    };
  },
  async created() {
    this.getFunds();
  },
  computed: {
    ...mapGetters([
      "getYear",
      "getMonth",
    ]),
    year: {
      get() {
        return this.getYear;
      },
      set(value) {
        this.setYear({ year: value });
      }
    },
    month: {
      get() {
        return this.getMonth;
      },
      set(value) {
        this.setMonth({ month: value });
      }
    },
    filteredFunds() {
      let filters = this.filters.filter(filter => filter.enabled == true).map(filter => filter.name);
      if(filters.includes("Google Ads")) { filters.push('Google Adwords'); }
      if(filters.includes("Display & Video 360")) { filters.push("DoubleClick"); }
      return this.funds.filter(fund => filters.includes(fund.type));
    },
    projectedTotal() {
      return this.filteredFunds.reduce((sum, fund) => sum + fund.projected, 0);
    },
    actualTotal() {
      return this.filteredFunds.reduce((sum, fund) => sum + fund.actual, 0);
    },
    pausedNetworks() {
      let pausedNetworks = [];
      let activeNetworks = [];
      this.prevFunds.map(prevFund => {
        var missingFund = true;
        this.funds.map(fund => {
          if( fund.type == prevFund.type && fund.client == prevFund.client ) {
            missingFund = false;
            if( fund.projected > 0 || fund.actual > 0 ) {
              activeNetworks.push(fund);
            } else if( prevFund.projected > 0 || prevFund.actual > 0) {
              pausedNetworks.push({'client': fund.client, 'type': fund.type});
            }
          }
        });
        if(missingFund) {
          pausedNetworks.push({'client': prevFund.client, 'type': prevFund.type});
        }
      });
      let total = pausedNetworks.filter(paused => {
        let isPaused = true;
        activeNetworks.map(active => {
          if( active.type == paused.type && active.client == paused.client ) {
            isPaused = false;
          }
        });
        return isPaused;
      });
      const uniqueFunds = total.reduce((acc, current) => {
        const x = acc.find(item => item.client + item.type === current.client + current.type);
        if(!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

      return uniqueFunds;
    },
    filteredPausedFunds() {
      let filters = this.filters.filter(filter => filter.enabled == true).map(filter => filter.name);
      if(filters.includes("Google Ads")) { filters.push('Google Adwords'); }
      if(filters.includes("Display & Video 360")) { filters.push("DoubleClick"); }
      return this.pausedNetworks.filter(fund => filters.includes(fund.type));
    },
  },
  methods: {
    ...mapActions([
      "setYear",
      "setMonth",
      "setListId",
    ]),
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    async getFunds() {
      let response = await this.$http.get("/paid-media-funds", {
        params: {
          year: this.getYear,
          month: this.getMonth,
          client: this.client,
        }
      });
      this.funds = response.data[0];
      this.prevFunds = response.data[1];
    }
  },
  watch: {
    'toggleFilters': function(val, oldVal) {
      this.filters.forEach(function(filter) {
        filter.enabled = val;
      });
    },
    month() {
      this.getFunds();
    },
    year() {
      this.getFunds();
    }
  }
};
</script>

<style lang="scss">
#fund-report {
  .toggle-trigger {
    cursor: pointer;
    margin-top: 20px;
    i.fa {
      transition: all .3s;
      margin-right: 10px;
      margin-left: 10px;
    }
    &.is-open {
      i.fa {
        transform: rotate(90deg);
      }
    }
  }
  .toggle-table {
    margin-bottom: 20px;

    * { transition: padding .3s }
    &:not(.is-open) {
      * {
        font-size: 0;
        padding-top: 0;
        padding-bottom: 0;
        border-width: 0px;
      }
    }
  }

  .switch-text {
    display: inline-block;
    position: absolute;
    margin-left: 40px;
    margin-bottom: 5px;
    font-size: 12px;
    vertical-align: middle;
    white-space: nowrap;
    cursor: pointer;
  }
  .totals {
    margin-top: 30px;

    td {
      font-size: 16px;
      font-weight: 700;
      color: $white;
      background: $blue;
    }
  }
  .filters {
    display: flex;
    flex-wrap: wrap;
    label {
      width: 25%;
      min-width: 180px;
      padding-right: 15px;
    }
  }
}
</style>
